import * as React from 'react';
import { useEffect, useMemo, useState } from "react";

import Particles from "react-tsparticles";

const ParticleBackground = () => {

    return (
      <Particles
      height="100vh" 
        options={{
          fullScreen: {
            enable: false,
          },
          particles: {
            number: {
              value: 200,
              limit: 300,
              density: {
                enable: true,
                value_area: 800
              }
            },
            color: {
              value: "#00FFFF"
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#00FFFF"
              },
              polygon: {
                nb_sides: 5
              },
              image: {
                src: "images/github.svg",
                width: 8,
                height: 8
              }
            },
            opacity: {
              value: 0.5,
              random: true,
              anim: {
                enable: true,
                speed: 1,
                opacity_min: 0.5,
                sync: false
              }
            },
            size: {
              value: 16,
              random: true,
              anim: {
                enable: true,
                speed: 10,
                size_min: 10,
                sync: false
              }
            },
            line_linked: {
              enable: true,
              distance: 100,
              color: "#00FFFF",
              opacity: 1,
              width: 1
            },
            move: {
              enable: true,
              speed: 3,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200
              }
            }
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onHover: {
                enable: true,
                mode: "bubble",
                parallax: {
                  enable: false,
                  force: 60,
                  smooth: 10
                }
              },
              onClick: {
                enable: true,
                mode: "push"
              },
              resize: true
            },
            modes: {
              grab: {
                distance: 400,
                lineLinked: {
                  opacity: 1
                }
              },
              bubble: {
                distance: 400,
                size: 16,
                duration: 2,
                opacity: 1,
                speed: 2
              },
              repulse: {
                distance: 200
              },
              push: {
                particles_nb: 4
              },
              remove: {
                particles_nb: 2
              }
            }
          },
         
          retina_detect: true,
          fps_limit: 60,
          background: {
            image: "url('https://firebasestorage.googleapis.com/v0/b/csemoguel.appspot.com/o/back.png?alt=media&token=f99d5efa-4549-4bbe-8b55-96bd6790864e')"
          }
        }}
      />
    )
}
export default ParticleBackground